module.exports = __webpack_public_path__ + "media/images/4-d9956b2c34f8ba883a73ea2a680c535a.jpg";